"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _logProgramChange = require("@studio/logger/datadog/logProgramChange");
var _SceneLayouts = require("@studio/constants/SceneLayouts");
var _getProgramLayers = require("@studio/program/utils/getProgramLayers");
var _setSceneLayout = _interopRequireDefault(require("./setSceneLayout"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * @param {Object} attendeeIds a map of attendeeIds. { someAttendeeId: 'someAttendeeId' }
 */
var _default = exports["default"] = function _default(attendeeIds, setProgram) {
  return function (dispatch, getState) {
    var _getState = getState(),
      program = _getState.program,
      attendeeCameraStatus = _getState.attendeeCameraStatus;
    var programLayoutId = program._id;
    var layout = _SceneLayouts.SceneLayouts.find(function (l) {
      return l.id === programLayoutId;
    });
    var layers = (0, _getProgramLayers.getProgramLayers)(program);
    var layerSource = layers.filter(function (layer) {
      return attendeeIds[layer.source.value];
    });

    // If source is in program we update the program scene
    if (layerSource.length) {
      var scene = _objectSpread(_objectSpread({}, program), {}, {
        layers: layers.map(function (ls) {
          var isCameraOn = attendeeCameraStatus[ls.source.value];
          if (typeof isCameraOn === 'boolean' && ls.layer) {
            ls.layer.isCameraOn = isCameraOn;
          }
          return ls;
        })
      });

      /*
        If it's a scene action i.e, when a scene is taken live,
        the layout is not valid, we don't want to set this.
      */
      if (layout) {
        dispatch((0, _setSceneLayout["default"])(layout));
      }
      // Dispatch action to setProgram
      dispatch(setProgram(scene, true, {
        emitSocket: false
      }));
      (0, _logProgramChange.logProgramChange)('updateProgramByCameraSource action');
    }
  };
};